import React from 'react';

type StravaIconProps = {
  className?: string;
};

const StravaLogo = ({ className }: StravaIconProps) => (
  <svg
    className={className}
    width="58"
    height="13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M10.005 6.62c.22.382.334.845.334 1.394v.033c0 .564-.114 1.076-.342 1.532a3.321 3.321 0 01-.959 1.154 4.587 4.587 0 01-1.504.727 7.1 7.1 0 01-1.979.256c-1.105 0-2.133-.154-3.088-.455C1.512 10.952.69 10.497 0 9.887l1.934-2.304c.59.455 1.207.78 1.858.976.65.195 1.296.292 1.934.292.33 0 .569-.04.711-.122.147-.081.216-.195.216-.341v-.033c0-.154-.106-.288-.317-.386-.212-.101-.606-.211-1.183-.325-.61-.126-1.19-.268-1.74-.435a6.045 6.045 0 01-1.454-.634 3.061 3.061 0 01-1-.975C.711 5.206.59 4.726.59 4.161V4.13c0-.516.102-.996.301-1.439a3.3 3.3 0 01.882-1.162c.386-.33.865-.585 1.438-.772C3.78.569 4.438.48 5.186.48c1.052 0 1.97.126 2.763.373.788.244 1.5.618 2.13 1.114L8.315 4.413a5.392 5.392 0 00-1.634-.812 5.662 5.662 0 00-1.617-.256c-.269 0-.468.04-.594.126-.13.08-.195.19-.195.325v.024c0 .146.098.268.293.374.195.102.577.211 1.146.325.69.122 1.32.272 1.89.447.564.179 1.056.402 1.463.675.402.272.719.597.938.98zm.134-2.877h3.19v7.77h3.626v-7.77h3.19V.679H10.139v3.064zM52.17 0l-5.832 11.513h3.47l2.361-4.661 2.361 4.661H58L52.168 0zM35.936 0l5.832 11.513h-3.47l-2.362-4.661-2.357 4.661h-6.49l-2.044-3.097h-.772v3.097h-3.621V.679h5.295c.971 0 1.768.11 2.39.333.625.223 1.125.524 1.507.906.33.33.577.703.744 1.114.163.414.248.898.248 1.455v.032c0 .793-.191 1.463-.573 2.012-.382.548-.902.983-1.565 1.3l1.882 2.747L35.937 0zm-8.709 4.747c0-.35-.126-.61-.374-.78-.248-.171-.585-.257-1.003-.257H24.27v2.122h1.564c.435 0 .776-.094 1.02-.28.248-.188.374-.444.374-.777v-.028zM46.414.679L44.053 5.34 41.692.679H38.22l5.832 11.513L49.88.679h-3.466z"
        fill="#FC4C02"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0h58v12.192H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default StravaLogo;
